import {Modal} from "semantic-ui-react";
import {CustomProvider, DatePicker, TimePicker} from "rsuite";
import ru_RU from "rsuite/esm/locales/ru_RU";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router";
import React, {useEffect, useState} from "react";
import {COUNTERS_PAGE_COUNT, fetchCounters} from "../../views/Counterparties/actions";
import {getAuthToken} from "../UserLogin/reducer";
import {getCounters} from "../../views/Counterparties/reducer";
import {createEvent} from "../../views/Events/actions";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";
import { ReactComponent as CloseIcon } from "../../icons/filter-close-button.svg";
import { Select } from "antd";


export default function CreatePopup(props) {
    const {
        isPopupOpen,
        setIsPopupOpen,
        options,
        inForm,
        counterId,
        currentCounter
    } = props;

    const token = useSelector((state) => getAuthToken(state.userLogin));
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const counters = useSelector((state) => getCounters(state.counters));
    const [usersOptions, setUsersOptions] = useState([]);

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    useEffect(() => {
        if (isPopupOpen && token && !inForm && counters.length === 0) {
            readCounters(1);
        }

    }, [isPopupOpen, token, inForm, counters.length]);


    // Устанавливаем пользователей для текущего контрагента при открытии в форме
    useEffect(() => {
        if (inForm && counterId && currentCounter?.users) {
            setUsersOptions(currentCounter.users.map((user) => ({
                text: languageString === 'ru' ? user?.full_name : user?.full_name_en,
                value: String(user.id),
            })));
        }
    }, [inForm, counterId, currentCounter, languageString]);

    useEffect(() => {
        const initialFormData = {
            ca_id: inForm ? counterId : '',
            name: '',
            on_date: '',
            on_time: '',
            duration: '',
            event_action: '',
            respondent_user: '',
            placement: '',
            add_info: '',
        };
        setFormData(initialFormData);
        setErrors({});
    }, [inForm, counterId]);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.ca_id) {
            newErrors.ca_id = t('requiredField');
        }
        if (!formData.name?.trim()) {
            newErrors.name = t('requiredField');
        }
        if (!formData.on_date) {
            newErrors.on_date = t('requiredField');
        }
        if (!formData.on_time) {
            newErrors.on_time = t('requiredField');
        }
        if (!formData.duration) {
            newErrors.duration = t('requiredField');
        }
        if (!formData.event_action) {
            newErrors.event_action = t('requiredField');
        }
        if (!formData.respondent_user) {
            newErrors.respondent_user = t('requiredField');
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleCreateEvent = async () => {
        if (!validateForm()) {
            return;
        }

        setIsLoading(true);
        setErrors({});

        try {
            const res = await dispatch(createEvent(token, formData.ca_id, {
                lang: languageString,
                respondent_exponent: counterId,
                name: formData.name,
                on_date: formData.on_date,
                on_time: formData.on_time,
                duration: formData.duration,
                respondent_user: formData.respondent_user,
                event_action: formData.event_action,
                placement: formData.placement,
                add_info: formData.add_info,
            }, t));

            if (res.code === 200) {
                setFormData({
                    ca_id: inForm ? counterId : '',
                    name: '',
                    on_date: '',
                    on_time: '',
                    duration: '',
                    event_action: '',
                    respondent_user: '',
                    placement: '',
                    add_info: '',
                });
                setIsPopupOpen(false);
            } else {
                if (res.message) {
                    setErrors({ general: res.message });
                } else {
                    setErrors({ general: t('createEventError') || 'Ошибка при создании события' });
                }
            }
        } catch (error) {
            console.error('Error creating event:', error);
            setErrors({ general: t('createEventError') || 'Ошибка при создании события' });
        } finally {
            setIsLoading(false);
        }
    };

    const now = new Date();
    const disabledDate = (date) => date < now.setHours(0, 0, 0, 0);

    const readCounters = (page, value) => {
        dispatch(fetchCounters(token, {
            page: page ? page : '',
            per_page: COUNTERS_PAGE_COUNT,
            order: 'desc',
            order_by: 'id',
            search: value,
        }, t));
    };

    // Создаем опции контрагентов
    const counterOptions = React.useMemo(() => {
        let options = counters.map(counter => ({
            value: counter.id,
            label: languageString==='ru' ? counter.name : counter.name_en,
            obj: counter,
        }));

        // Если мы в форме контрагента и у нас есть данные текущего контрагента,
        // но его нет в списке, добавляем его
        if (inForm && currentCounter && !options.find(opt => opt.value === currentCounter.id)) {
            const billingData = languageString === 'ru' ? currentCounter.billing : currentCounter.billing_en;
            options.unshift({
                value: currentCounter.id,
                label: languageString === 'ru' ? currentCounter.name : currentCounter.name_en,
                obj: currentCounter,
            });
        }

        return options;
    }, [counters, inForm, currentCounter, languageString]);

    const handleChange = (e) => {
        const {name, value} = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

        if (errors[name] && value.trim()) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    }

    const handleChangeDate = (value) => {
        const dateValue = value?.toLocaleDateString().split('.').reverse().join('-');
        setFormData({
            ...formData,
            on_date: dateValue,
        });

        if (errors.on_date && dateValue) {
            setErrors(prev => ({
                ...prev,
                on_date: ''
            }));
        }
    }

    const handleCleanDate = () => {
        setFormData({
            ...formData,
            on_date: ''
        })
    }

    const handleChangeTime = (value) => {
        setFormData({
            ...formData,
            on_time: value?.toLocaleTimeString(ru_RU, { hour: '2-digit', minute: '2-digit' })
        });

        if (errors.on_time) {
            setErrors(prev => ({
                ...prev,
                on_time: ''
            }));
        }
    }

    const handleCleanTime = () => {
        setFormData({
            ...formData,
            on_time: ''
        })
    }

    const handleChangeDuration = (e) => {
        let value = e.target.value.replace(/[^0-9]/g, "");

        let formattedValue = "";
        if (value.length > 0) {
            formattedValue += value.substring(0, 2);
        }
        if (value.length > 2) {
            formattedValue += ":" + value.substring(2, 4);
        }

        if (+value.substring(0,2) > 23) {
            formattedValue = '23';
        }

        if (+value.substring(2,4) > 59) {
            formattedValue = value.substring(0, 2) + ':' + '59';
        }

        setFormData({ ...formData, duration: formattedValue });

        if (errors.duration && formattedValue) {
            setErrors(prev => ({
                ...prev,
                duration: ''
            }));
        }
    };

    const handleChangeUser = (value) => {
        setFormData({
            ...formData,
            respondent_user: value,
        });

        if (errors.respondent_user && value) {
            setErrors(prev => ({
                ...prev,
                respondent_user: ''
            }));
        }
    }

    const handleChangeEvent = (value) => {
        setFormData({
            ...formData,
            event_action: value,
        });

        if (errors.event_action && value) {
            setErrors(prev => ({
                ...prev,
                event_action: ''
            }));
        }
    }

    const handleChangeCounter = (value, option) => {
        setFormData({
            ...formData,
            ca_id: value
        });

        if (errors.ca_id && value) {
            setErrors(prev => ({
                ...prev,
                ca_id: ''
            }));
        }

        // Находим выбранный контрагент и обновляем список пользователей
        const selectedCounter = counterOptions.find(item => item.value === value);
        if (selectedCounter && selectedCounter.obj && selectedCounter.obj.users) {
            const users = selectedCounter.obj.users;
            setUsersOptions(users.map((user) => ({
                text: languageString === 'ru' ? user?.full_name : user?.full_name_en,
                value: String(user.id),
            })));
        } else {
            setUsersOptions([]);
        }
    }

    const handleSearchChange = (value) => {
        if (value && value.length > 3) {
            readCounters(1, value);
        }
        if (value.length === 0 ) {
            readCounters(1, value);
        }
    }

    const handleCloseModal = () => {
        setIsPopupOpen(false);
    }

    console.log(options)
    return (
        <Modal
            className='events-create-modal'
            open={isPopupOpen}
            trigger={
                inForm ? <div className='cform-event-btn' onClick={() => {
                        setIsPopupOpen(true)
                    }}>{t('createEvent')}</div>
                    :
                    <button
                        className="counter-btn btn-red"
                        onClick={() => setIsPopupOpen(true)}
                    >
                        {t('createBtn')}
                    </button>
            }
            onClose={handleCloseModal}
            centered={true}
        >
            <Modal.Content className='events-modal-content'>
                <div className='events-popup'>
                    <CloseIcon className='events-close-icon' onClick={handleCloseModal} />

                    {errors.general && (
                        <div className="events-error-message">
                            {errors.general}
                        </div>
                    )}

                    <CustomProvider locale={languageString === 'ru' ? ru_RU : undefined}>
                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('counterparty')}</label>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                className={`cform-drop ${errors.ca_id ? 'cform-drop-error' : ''}`}
                                options={counterOptions}
                                value={formData.ca_id}
                                disabled={inForm}
                                onChange={handleChangeCounter}
                                onSearch={handleSearchChange}
                                placeholder={t('selectCounterparty')}
                                notFoundContent="Ничего не найдено"
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }
                            />
                            {errors.ca_id && <div className="cform-field-error">{errors.ca_id}</div>}
                        </div>

                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('nameEvent')}</label>
                            <input
                                className={`cform-input ${errors.name ? 'cform-input-error' : ''}`}
                                name='name'
                                value={formData.name}
                                onChange={handleChange}
                                type="text"
                            />
                            {errors.name && <div className="cform-field-error">{errors.name}</div>}
                        </div>

                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('start')}</label>
                            <div className='events-datetime-container'>
                                <div>
                                    <DatePicker
                                        onChange={handleChangeDate}
                                        onClean={handleCleanDate}
                                        shouldDisableDate={disabledDate}
                                        format="dd/MM/yyyy"
                                        style={{ width: '100%' }}
                                        character=" – "
                                        appearance='subtle'
                                        placeholder={t('date')}
                                        ranges={[]}
                                        size='xs'
                                    />
                                    {errors.on_date && <div className="cform-field-error">{errors.on_date}</div>}
                                </div>
                                <div>
                                    <TimePicker
                                        placeholder={t('time')}
                                        onChange={handleChangeTime}
                                        style={{ width: '100%' }}
                                        showMeridiem={languageString !== 'ru'}
                                        onClean={handleCleanTime}
                                        size='xs'
                                    />
                                    {errors.on_time && <div className="cform-field-error">{errors.on_time}</div>}
                                </div>
                            </div>
                        </div>

                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('duration')}</label>
                            <input
                                type="text"
                                value={formData.duration}
                                className={`cform-input ${errors.duration ? 'cform-input-error' : ''}`}
                                onChange={handleChangeDuration}
                                placeholder={languageString === 'ru' ? 'чч:мм' : 'hh:mm'}
                                maxLength={5}
                            />
                            {errors.duration && <div className="cform-field-error">{errors.duration}</div>}
                        </div>

                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('employee')}</label>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                options={[{
                                    label: languageString === 'ru' ? 'Любой сотрудник' : 'Any employee',
                                    value: '0'
                                }, ...(inForm ?
                                        (options?.usersOptions || usersOptions).map(option => ({
                                            label: option.text,
                                            value: option.value
                                        })) :
                                        usersOptions.map(option => ({
                                            label: option.text,
                                            value: option.value
                                        }))
                                )]}
                                className={`cform-drop ${errors.respondent_user ? 'cform-drop-error' : ''}`}
                                value={formData.respondent_user}
                                onChange={handleChangeUser}
                                placeholder={t('selectEmployee')}
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }
                            />
                            {errors.respondent_user && <div className="cform-field-error">{errors.respondent_user}</div>}
                        </div>

                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('eventType')}</label>
                            <Select
                                showSearch
                                style={{ width: '100%' }}
                                options={options.typeMeetingOptions}
                                className={`cform-drop ${errors.event_action ? 'cform-drop-error' : ''}`}
                                value={formData.event_action}
                                onChange={handleChangeEvent}
                                placeholder={t('selectEventType')}
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().includes(input.toLowerCase())
                                }
                            />
                            {errors.event_action && <div className="cform-field-error">{errors.event_action}</div>}
                        </div>

                        <div className="cform-input-ctn">
                            <label className="cform-label">{t('description')}</label>
                            <textarea
                                className="cform-input"
                                name='add_info'
                                value={formData.add_info}
                                onChange={handleChange}
                            />
                        </div>

                    </CustomProvider>

                    <div className='events-btn-container'>
                        <button
                            className='events-btn btn-red'
                            onClick={handleCreateEvent}
                            disabled={isLoading}
                        >
                            {isLoading ? (languageString === 'ru' ? 'Создание...' : 'Creating...') : t('create')}
                        </button>
                        <button
                            onClick={handleCloseModal}
                            className='events-btn btn-white'
                            disabled={isLoading}
                        >
                            {t('cancel')}
                        </button>
                    </div>
                </div>
            </Modal.Content>
        </Modal>
    )
}